import * as routerNames from '@/services/router/router.names'

import PeopleHome from '@/screens/people/people-home.vue'
import PeopleCreate from '@/screens/people/people-create.vue'
import PersonDetail from '@/screens/people/person-detail.vue'
import GuestsHome from '@/screens/guest/guest-home.vue'
import GuestsCreate from '@/screens/guest/guest-create.vue'
import GuestsDetail from '@/screens/guest/guest-detail.vue'
import CompanyGuestsCreate from '@/screens/guest/company-create.vue'
import CompanyGuestsDetail from '@/screens/guest/company-detail.vue'
import CompanyCreate from '@/screens/people/company-create.vue'
import CompanyDetail from '@/screens/people/company-detail.vue'

export default [
  {
    path: '/:accountId/users',
    name: routerNames.PEOPLE,
    component: PeopleHome,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/users/new',
    name: routerNames.PEOPLE_CREATE,
    component: PeopleCreate,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/users/:accountMembershipId',
    name: routerNames.PERSON_DETAIL,
    component: PersonDetail,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/guests',
    name: routerNames.GUESTS,
    component: GuestsHome,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/guests/new',
    name: routerNames.GUESTS_CREATE,
    component: GuestsCreate,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/guests/:accountMembershipId',
    name: routerNames.GUESTS_DETAIL,
    component: GuestsDetail,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/company/new',
    name: routerNames.COMPANY_CREATE,
    component: CompanyCreate,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/company-guests/new',
    name: routerNames.COMPANY_GUESTS_CREATE,
    component: CompanyGuestsCreate,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/company/:companyId',
    name: routerNames.COMPANY_DETAIL,
    component: CompanyDetail,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/company-guests/:companyId',
    name: routerNames.COMPANY_GUESTS_DETAIL,
    component: CompanyGuestsDetail,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/company/:companyId/people/new',
    name: routerNames.COMPANY_PEOPLE_CREATE,
    component: PeopleCreate,
    meta: {
      adminOwnerOnly: true,
    },
  },
]
